import Styled, { css } from 'styled-components';

import { media } from '../../../../lib/StyledComponents';

import { IVerTaskCard } from './common';

export const TaskThumb = Styled.div<IVerTaskCard>`
  margin-right: 0.75em;
  display: none;
  color:
    ${({ theme: { taskCard }, isComplete, inReview, preventCompleteColor }) => (
      !preventCompleteColor && (inReview || isComplete)
        ? taskCard.colorCompleteText
        : taskCard.colorIcon
    )};

  ${media.small`
    margin-right: 1em;
    display: flex;
    align-content: center;
    align-items: center;
  `}

  ${({ theme: { taskCard }}) => taskCard.taskThumb && css`
    ${taskCard.taskThumb.margin && css`
      margin: ${taskCard.taskThumb.margin.mobile};

      ${media.small`
        margin: ${taskCard.taskThumb.margin.small};
      `}
    `}
  `}
`;
